import React from 'react';
import { observer } from 'mobx-react-lite';
import { toChoiceQuestionAnswerOrEmpty } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { EditSingleChoice } from './edit/EditSingleChoice';
import { ViewSingleChoice } from './view/ViewSingleChoice';
export var SingleChoice = observer(function (_ref) {
  var _currentAnswer$choice;
  var id = _ref.id,
    errorId = _ref.errorId,
    descriptionId = _ref.descriptionId,
    questionStore = _ref.questionStore,
    displayMode = _ref.displayMode;
  var availableOptions = questionStore.availableOptions();
  var currentAnswer = toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer);
  var currentChoiceId = (_currentAnswer$choice = currentAnswer.choices) !== null && _currentAnswer$choice !== void 0 && _currentAnswer$choice.length ? currentAnswer.choices[0] : undefined;
  var currentOption = availableOptions.find(function (option) {
    return option.value === currentChoiceId;
  });
  var hasOtherChoice = !!questionStore.otherChoiceId;
  var showEditComponent = displayMode === DisplayMode.Edit;
  if (showEditComponent) {
    var _questionStore$formQu;
    var onChange = function onChange(event) {
      var selectedChoiceId = event.target.value;
      var newChoiceId = selectedChoiceId ? [selectedChoiceId] : [];
      questionStore.setAnswer({
        text: hasOtherChoice && selectedChoiceId === questionStore.otherChoiceId ? toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer).text : '',
        choices: newChoiceId
      });
    };
    var otherChoiceSelected = hasOtherChoice && currentChoiceId === questionStore.otherChoiceId;
    var onOtherChoiceTextChange = function onOtherChoiceTextChange(event) {
      questionStore.setAnswer({
        text: event.target.value,
        choices: toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer).choices
      });
    };
    return /*#__PURE__*/React.createElement(EditSingleChoice, {
      id: id,
      errorId: errorId,
      descriptionId: descriptionId,
      options: availableOptions,
      value: currentOption,
      isInvalid: !!questionStore.validationErrors,
      isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 || (_questionStore$formQu = _questionStore$formQu.validation) === null || _questionStore$formQu === void 0 ? void 0 : _questionStore$formQu.rq,
      onChange: onChange,
      hasOtherOption: hasOtherChoice,
      otherOptionSelected: otherChoiceSelected,
      otherOptionText: currentAnswer.text,
      onOtherOptionTextChange: onOtherChoiceTextChange
    });
  }
  return /*#__PURE__*/React.createElement(ViewSingleChoice, {
    id: id,
    options: availableOptions,
    value: currentOption,
    hasOtherOption: hasOtherChoice,
    otherOptionText: currentAnswer.text,
    displayMode: displayMode
  });
});